import { useCallback, useEffect, useState } from 'react';

import { SingleSelection } from '../../../../components';
import { SelectChangeEvent } from '../../../../components/MuiGenerals';
import { useTranslation } from '../../../../hooks';
import { EnumE6CardState } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: SelectChangeEvent) => void;
  onClear: () => void;
}

const E6CardStatusSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { tc, t } = useTranslation('enumConstants');
  
  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('e6CardStatus') })}
      value={value || ''}
      clearSelect={onClear}
      onChange={onChange}
      enumData={EnumE6CardState}
      nameFn={(item) => t(item)}
    />
  );
};

export default E6CardStatusSingleSelection;
